<script>
    import { allProjectFields, allTemplateFields } from "../../Participaid.svelte";

    import LoadingSpinner from "../LoadingSpinner.svelte";
    import Reporter from "../../lib/error.js";

    import Select, {Option} from '@smui/select';
    import Icon from '@smui/select/icon/index';
    import HelperText from '@smui/select/helper-text/index';
    import Button, {Group, GroupItem, Label} from '@smui/button';

    export let selectedId = "HOUR_RATE";
    export let disabled;
    //export let selected;
    export let isTime = false;
    export let label = "Formula type";
    export let help = `
        The preset type of formula to use.
        The 'Year salary' calculates the contribution value based on the contributor's configured yearly salary.
        'Hour rate' calculates the contribution value based on the configured hourly rate.
        And 'Commission' calculates a fee for the contributor based on a given percentage.
    `;

    // TODO: get from API
    const time_options = [
        //"NONE",
        //"IDENTITY",
        "HOUR_RATE",
        "YEAR_SALARY",
        //"COMMISSION_GENERAL",
        //"COMMISSION_COLLABORATOR"
    ];

    const currency_options = [
        //"NONE",
        "IDENTITY",
        //"YEAR_SALARY",
        //"HOUR_RATE",
        "COMMISSION_GENERAL",
        "COMMISSION_COLLABORATOR"
    ];

    $: options = isTime ? time_options : currency_options;

    $: if (!selectedId) {
        //log(`selecting first company...`);
        selectedId = options[0];
    }

</script>

<Select enhanced variant="outlined" withLeadingIcon bind:value={selectedId} {label} {disabled} style="width: 100%">
    <span slot="icon"><Icon class="material-icons">work</Icon></span>
    {#if options}
        {#each options as option}
            <Option
                    value="{option}"
                    selected={selectedId == option}>
            {#if option == "IDENTITY"}
                none
            {:else}
                {option.toLowerCase().replace("_", " ")}
            {/if}
            </Option>
        {/each}
    {/if}
</Select>

{#if help}
    <HelperText id="helper-text-persistent-c" persistent>{help}</HelperText>
{/if}

<style>
    option {
        text-transform: capitalize;
    }
</style>